<h3>{{ 'admin.media.titre' | traduire }}</h3>

<div class="form-upload">
  <label class="btn-import" [class.desactive]="importEnCours">
    {{ importEnCours ? ('admin.media.importEnCours' | traduire) : ('📁 ' + ('admin.media.importer' | traduire)) }}
    <input type="file" accept="image/*" (change)="onFichierSelectionne($event)" [disabled]="importEnCours">
  </label>
  <input type="text" class="recherche" [(ngModel)]="recherche" [placeholder]="'admin.media.rechercher' | traduire">
  <p class="confirmation" *ngIf="messageConfirmation">{{ messageConfirmation }}</p>
</div>

<p class="astuce">{{ 'admin.media.explication' | traduire }}</p>

<p *ngIf="chargementEnCours" style="color:#888;">{{ 'admin.media.chargement' | traduire }}</p>

<div class="media-grid" *ngIf="!chargementEnCours">
  <div class="media-item" *ngFor="let img of imagesFiltrees">
    <button class="btn-supprimer" (click)="supprimer(img)" [title]="'admin.media.supprimerBtn' | traduire">🗑</button>
    <img [src]="img.url" [alt]="img.nom" loading="lazy">
    <div class="media-info">
      <span class="nom" [title]="img.nom">{{ img.nom }}</span>
      <span class="meta">{{ formatTaille(img.taille) }} · {{ img.date }}</span>
      <button (click)="copierUrl(img.url)">
        {{ urlCopiee === img.url ? ('admin.media.copie' | traduire) : ('admin.media.copierUrl' | traduire) }}
      </button>
    </div>
  </div>

  <p *ngIf="imagesFiltrees.length === 0" style="color:#888;">
    {{ recherche ? ('admin.media.videResultat' | traduire) : ('admin.media.vide' | traduire) }}
  </p>
</div>
